import { call, put, takeLatest } from "redux-saga/effects";
import Swal from "sweetalert2";

import {
    FETCH_DEMANDES_RECRUTEMENT_REQUEST,
    fetchDemandesRecrutementSuccess,
    fetchDemandesRecrutementFail,

    CREATE_DEMANDE_RECRUTEMENT_REQUEST,
    createDemandeRecrutementSuccess,
    createDemandeRecrutementFail,

    UPDATE_DEMANDE_RECRUTEMENT_REQUEST,
    updateDemandeRecrutementSuccess,
    updateDemandeRecrutementFail,

    DELETE_DEMANDE_RECRUTEMENT_REQUEST,
    deleteDemandeRecrutementSuccess,
    deleteDemandeRecrutementFail,

    APPROVE_DEMANDE_RECRUTEMENT_REQUEST,
    approveDemandeRecrutementSuccess,
    approveDemandeRecrutementFail,

    REJECT_DEMANDE_RECRUTEMENT_REQUEST,
    rejectDemandeRecrutementSuccess,
    rejectDemandeRecrutementFail,

    CANCEL_DEMANDE_RECRUTEMENT_REQUEST,
    cancelDemandeRecrutementSuccess,
    cancelDemandeRecrutementFail,

    setDemandesRecrutementLoading,


    sendOfferToChasseursSuccess,
    sendOfferToChasseursFail,
    sendOfferToPartenairesSuccess,
    sendOfferToPartenairesFail,
} from "../actions/demandesRecrutementActions";

import {
    API_BASE_URL,
    getRequest,
    postRequest,
    putRequest,
    deleteRequest,
} from "../../../api";

const getUid = () => sessionStorage.getItem("uid");
const getToken = () => sessionStorage.getItem("token");

export function buildDemandeRecrutementFormData(payload) {
    const fd = new FormData();

    const descriptifPosteFile = payload?.descriptifPosteFile || null;

    const clean = { ...payload };
    delete clean.descriptifPosteFile;

    fd.append("payload", JSON.stringify(clean));

    if (descriptifPosteFile) {
        fd.append("descriptifPoste", descriptifPosteFile);
    }

    return fd;
}

export function* fetchDemandesRecrutementSaga() {
    const url = `${API_BASE_URL}/api/demandes-recrutement`;
    const uid = getUid();
    const token = getToken();

    yield put(setDemandesRecrutementLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchDemandesRecrutementSuccess(resp.data));
    } catch (e) {
        yield put(fetchDemandesRecrutementFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setDemandesRecrutementLoading(false));
    }
}

export function* createDemandeRecrutementSaga(action) {
    const url = `${API_BASE_URL}/api/demandes-recrutement`;
    const uid = getUid();
    const token = getToken();

    yield put(setDemandesRecrutementLoading(true));
    try {
        const fd = buildDemandeRecrutementFormData(action.payload);

        const resp = yield call(postRequest, {
            url,
            data: fd,
            uid,
            token,
            headers: { "Content-Type": "multipart/form-data" },
        });

        yield put(createDemandeRecrutementSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Demande de recrutement ajoutée",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({ type: FETCH_DEMANDES_RECRUTEMENT_REQUEST });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur ajout demande";
        yield put(createDemandeRecrutementFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setDemandesRecrutementLoading(false));
    }
}

export function* updateDemandeRecrutementSaga(action) {
    const { id, payload } = action.payload;
    const url = `${API_BASE_URL}/api/demandes-recrutement/${id}`;
    const uid = getUid();
    const token = getToken();

    yield put(setDemandesRecrutementLoading(true));
    try {
        const fd = buildDemandeRecrutementFormData(payload);

        const resp = yield call(putRequest, {
            url,
            data: fd,
            uid,
            token,
            headers: { "Content-Type": "multipart/form-data" },
        });

        yield put(updateDemandeRecrutementSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Demande de recrutement modifiée",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({ type: FETCH_DEMANDES_RECRUTEMENT_REQUEST });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur modification demande";
        yield put(updateDemandeRecrutementFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setDemandesRecrutementLoading(false));
    }
}

export function* deleteDemandeRecrutementSaga(action) {
    const { id } = action.payload;
    const url = `${API_BASE_URL}/api/demandes-recrutement/${id}`;
    const uid = getUid();
    const token = getToken();

    yield put(setDemandesRecrutementLoading(true));
    try {
        yield call(deleteRequest, { url, uid, token });
        yield put(deleteDemandeRecrutementSuccess(id));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Demande de recrutement supprimée",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur suppression demande";
        yield put(deleteDemandeRecrutementFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setDemandesRecrutementLoading(false));
    }
}

export function* approveDemandeRecrutementSaga(action) {
    const { id } = action.payload;
    const url = `${API_BASE_URL}/api/demandes-recrutement/${id}/approve`;
    const uid = getUid();
    const token = getToken();

    yield put(setDemandesRecrutementLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            data: {},
            uid,
            token,
        });

        yield put(approveDemandeRecrutementSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Demande approuvée",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur approbation demande";
        yield put(approveDemandeRecrutementFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setDemandesRecrutementLoading(false));
    }
}

export function* rejectDemandeRecrutementSaga(action) {
    const { id, motif } = action.payload;
    const url = `${API_BASE_URL}/api/demandes-recrutement/${id}/reject`;
    const uid = getUid();
    const token = getToken();

    yield put(setDemandesRecrutementLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            data: { motif },
            uid,
            token,
        });

        yield put(rejectDemandeRecrutementSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Demande rejetée",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur rejet demande";
        yield put(rejectDemandeRecrutementFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setDemandesRecrutementLoading(false));
    }
}

export function* cancelDemandeRecrutementSaga(action) {
    const { id, motif } = action.payload;
    const url = `${API_BASE_URL}/api/demandes-recrutement/${id}/cancel`;
    const uid = getUid();
    const token = getToken();

    yield put(setDemandesRecrutementLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            data: { motif },
            uid,
            token,
        });

        yield put(cancelDemandeRecrutementSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Demande annulée",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur annulation demande";
        yield put(cancelDemandeRecrutementFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setDemandesRecrutementLoading(false));
    }
}

export function* sendOfferToChasseursSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/demandes-recrutement/send-offer-to-chasseurs`;
    const data = action.payload;

    try {
        yield call(postRequest, { url, data, token });
        yield put(sendOfferToChasseursSuccess());

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: 'Offre envoyée aux chasseurs sélectionnés avec succès',
            timer: 2500,
            showConfirmButton: false,
        });
    } catch (error) {
        yield put(sendOfferToChasseursFail(error.message));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: error.message || 'Erreur lors de l’envoi aux chasseurs',
            timer: 3000,
            showConfirmButton: false,
        });
    }
}

export function* sendOfferToPartenairesSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/demandes-recrutement/send-offer-to-partenaires`;
    const data = action.payload;

    try {
        yield call(postRequest, { url, data, token });
        yield put(sendOfferToPartenairesSuccess());

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: 'Offre envoyée aux partenaires sélectionnés avec succès',
            timer: 2500,
            showConfirmButton: false,
        });
    } catch (error) {
        yield put(sendOfferToPartenairesFail(error.message));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: error.message || 'Erreur lors de l’envoi aux partenaires',
            timer: 3000,
            showConfirmButton: false,
        });
    }
}